import { graphql } from '~/gql'

export default graphql(`
  query ProductHeater($productId: ID!) {
    Product(id: $productId) {
      ...HeaterFragment
    }
  }
`)
